import React from "react";
import { useRecoilState } from "recoil";
import { toast } from "react-toastify";
import { useModal } from "../../../Modal/Modal";
import { SavedSearch } from "../../../../types/SavedSearchTypes";
import { CountedSavedSearchesAtom } from "../../../../atoms/SavedSearches";
import { deleteSavedSearch } from "../../../../api/SavedSearches";
import Warning from "../../../Modal/container/Warning";

interface Props {
  search: SavedSearch;
}

export const DeleteSearchModal = (props: Props): JSX.Element => {
  const { search } = props;
  const { id, name } = search;
  const [savedSearches, setSavedSearches] = useRecoilState(
    CountedSavedSearchesAtom
  );
  const modalHandler = useModal();

  function deleteSearch(searchId: string) {
    setSavedSearches(
      savedSearches.filter((currentSearch) => currentSearch.id !== searchId)
    );
  }

  return (
    <Warning
      title="Delete Saved Search"
      icon={'./icons/delete.svg'}
      description={`Are you sure you want to delete your saved search “${name}”?`}
      onOkClicked={async () => {
        if (await deleteSavedSearch(id)) {
          deleteSearch(id);
        } else {
          toast(
            "There was an error deleting the saved search, try again in a minute",
            { type: "error" }
          );
        }
        modalHandler.popModal();
      }}
      onCancelClicked={() => modalHandler.popModal()}
      buttonsName={["No", "Yes"]}
    />
  );
};
